import type { JSX } from 'react';

import { useAlert } from 'hooks';
import { Icon } from 'components/icon';
import { textValue } from 'utils/helpers';
import { EllipsisText } from 'components/ellipsis-text';

import * as Styles from './styles';
import { ClipboardItemProps } from './types';

const ClipboardItem = ({
  icon,
  title,
  largeTitle,
  clipboardText,
  clipboardValue,
}: ClipboardItemProps): JSX.Element => {
  const { showSuccessAlert } = useAlert();
  return (
    <Styles.Wrapper>
      {icon && <div>{icon}</div>}
      <Styles.Column>
        {title && (
          <EllipsisText>
            {largeTitle ? (
              <h2>{title}</h2>
            ) : (
              <Styles.Title>{title}</Styles.Title>
            )}
          </EllipsisText>
        )}

        <Styles.Row>
          <EllipsisText>
            <p>{textValue(clipboardText)}</p>
          </EllipsisText>

          {clipboardText && (
            <Icon.Copy
              onClick={() => {
                navigator.clipboard.writeText(clipboardValue ?? clipboardText);
                showSuccessAlert('Copied to clipboard');
              }}
            />
          )}
        </Styles.Row>
      </Styles.Column>
    </Styles.Wrapper>
  );
};

export { ClipboardItem };
